<template>
  <div>
    <b-modal v-model="showModal"
      title="Datos del registro"
      header-bg-variant="secondary"
      header-text-variant="white"
      scrollable
      @close="close"
      @show="getRecord"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc>
      <div><span><b>Rol:</b> {{ record.name }}</span></div>
      <div><span><b>Permisos:</b> {{ record.permissions_label }}</span></div>
      <div><span><b>Usuarios con este rol:</b> {{ record.users_total }}</span></div>
      <div><span><b>Administrador de Módulo:</b> {{ record.is_module_admin ? 'Sí' : 'No' }}</span></div>
      <div><span><b>Rol del sistema:</b> {{ record.is_protected ? 'Sí' : 'No' }}</span></div>
      <div><span><b>Estado:</b> {{ record.status === 1 ? 'Activo' : 'Inactivo' }}</span></div>
        <div class="modal-footer">
          <button class="btn btn-sm btn-danger" type="button" @click="close"> <i class="fas fa-times fa-fw"></i>Cerrar</button>
        </div>
    </b-modal>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import { BModal } from 'bootstrap-vue';

export default {
  components: {BModal},
  props: ['record', 'showModal'],
  data() {
    return {
      form: {},
      loading: false,
    }
  },
  methods:{
    close(bvModalEvent) {
      this.$emit('update:showModal', false)
    },
    getRecord() {
      this.loading = true
      this.form = {
        id: this.id
      }
    },
  }
}

</script>
